import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    darkPrimary: "#0d4000",
    lightPrimary: "#4fff00",
    primary: "#349400",
    second: "#6bc200",
    grayBg: "#E1E1E1",
    grayTxt: "#999999",
    grayTitle: "#666",
  },
  components: {
    Checkbox: {
      baseStyle: {
        label: {
          color: "grayTxt",
          _checked: {
            color: "second",
          },
        },
        control: {
          _checked: {
            bg: "second",
            borderColor: "second",
            color: "second",
          },
        },
      },
    },
    Button: {
      variants: {
        solid: {
          bg: "second",
          color: "white",
          _hover: {
            opacity: "0.8",
          },
          fontWeight: "400",
        },
        outline: {
          color: "second",
          borderColor: "second",
          _hover: {
            opacity: "0.8",
          },
          fontWeight: "400",
        },
      },
      defaultProps: {
        variant: "solid",
      },
    },
    Tabs: {
      baseStyle: {
        tab: {
          _selected: {
            color: "second",
          },
        },
      },
    },
  },
});

export default theme;
